module.exports = __webpack_public_path__ + "static/tpp-image05-e48b6b4a74d3f16d5cb855be7ce54d7a.png";